/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template "model.velocity"
 */

/**
 * THIS Template MUST remain FRAMEWORK INDEPENDENT!! It is used for Angular, Ionic, Node-Express... any JavaScript framework
 */

/* tslint:disable */


export class PartyAddressDetail {
    streetName?: string; // ecf001
    houseNumber?: number; // ecf001
    postalCode?: string; // ecf001
    cityName?: string; // ecf001
    countryIsoCode?: string; // ecf001


    // <editor-fold desc="From and To Json Methods" defaultstate="collapsed">
/**
 * DO NOT MODIFY, your changes will be lost on next generation!
 * Generated code from template &quot;model-json.velocity&quot;
 */

    /** ---- Generated part from .\ang-man\src\modules\generator\writers\common\templates\model-json.velocity */

    public static mergeJSON(instance: any, data: any): PartyAddressDetail {
        if (!data) { return instance; }
        if (data.streetName != null) {instance.streetName = data.streetName; }
        if (data.houseNumber != null) {instance.houseNumber = data.houseNumber; }
        if (data.postalCode != null) {instance.postalCode = data.postalCode; }
        if (data.cityName != null) {instance.cityName = data.cityName; }
        if (data.countryIsoCode != null) {instance.countryIsoCode = data.countryIsoCode; }
        return instance; // ir
    }

    public fromJSON(data: any): this { // cbn001
        return PartyAddressDetail.mergeJSON(this, data) as any;
    }

    public static mergeJSONFromObject(target: any, object: PartyAddressDetail) {
        // TODO: mapping
        return object;
    }

    // toJSON ensures that only class-defined fields are exported.
    public toJSON() {
        return PartyAddressDetail.mergeJSONFromObject({}, this);
    }

    // Compares this AppInfo instance with another AppInfo instance, recursively.
    // Transient fields are not considered.
    public equals(other: PartyAddressDetail): boolean {
        return JSON.stringify(this.toJSON()) === JSON.stringify(other.toJSON());
    }

    /** ---- */


/** end of template &quot;model-json.velocity&quot; */

    // </editor-fold>

}


/** end of template "model.velocity" */
